"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ValidationErrors_1 = require("../../enums/Validation/ValidationErrors");
const Resource_1 = __importDefault(require("../Resource"));
const CustomAsync_1 = __importDefault(require("../decorators/CustomAsync"));
const Di_1 = __importDefault(require("../injectables/Di"));
class VoteCreateRequestResource extends Resource_1.default {
}
exports.default = VoteCreateRequestResource;
__decorate([
    (0, class_validator_1.IsUUID)(4),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], VoteCreateRequestResource.prototype, "questionId", void 0);
__decorate([
    (0, CustomAsync_1.default)((id) => Di_1.default.getChoiceService().exists(id), {
        message: ValidationErrors_1.EValidationError.choiceNotExists,
    }),
    (0, CustomAsync_1.default)((id, args) => Di_1.default.getChoiceService().isChoiceBelongToQuestion(id, args.object.questionId), {
        message: ValidationErrors_1.EValidationError.choiceNotExists,
    }),
    (0, class_validator_1.IsUUID)(4),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], VoteCreateRequestResource.prototype, "choiceId", void 0);
